import React from "react";

import { Button, FieldGrid, LabeledField, SectionCard } from "shared/ui";
import { formatPhoneNumber } from "shared/lib/phoneNumber";

import { useAccountContext } from "features/Account/context";
import { Value } from "features/Account/styles";

export const ProfileCard = () => {
    const { account, logout } = useAccountContext();

    if (!account) return null;

    return (
        <SectionCard
            title="Профиль"
            headerRight={
                <Button variant="outlined" color="danger" onClick={logout}>
                    Выйти из аккаунта
                </Button>
            }
        >
            <FieldGrid $min={220}>
                <LabeledField label="Телефон">
                    <Value>{formatPhoneNumber(account.phoneNumber)}</Value>
                </LabeledField>

                {/* Имя и почту кабинет не заполняет — показываем, только если они есть. */}
                {account.name && (
                    <LabeledField label="Имя">
                        <Value>{account.name}</Value>
                    </LabeledField>
                )}

                {account.email && (
                    <LabeledField label="Email">
                        <Value>{account.email}</Value>
                    </LabeledField>
                )}
            </FieldGrid>
        </SectionCard>
    );
};
